<template>
  <div class="info-page">
    <h4>无法访问此网站</h4>
    <p>非常抱歉，您的IE浏览器版本过低</p>
    <p>为了您能正常使用618保险网站功能，推荐使用以下浏览器：</p>
    <div class="brower-list">
      <div class="brower-item">
        <img src="@/assets/image/ieError/google.png" />
        <span>谷歌浏览器</span>
      </div>
      <div class="brower-item">
        <img src="@/assets/image/ieError/firefox.png" />
        <span>火狐浏览器</span>
      </div>
      <div class="brower-item">
        <img src="@/assets/image/ieError/360.png" />
        <span>360浏览器</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.info-page {
  box-sizing: border-box;
  background: url('~@/assets/image/ieError/infoBg.png') no-repeat center center;
  background-size: cover;
  width: 100vw;
  padding-top: 30vh;
  padding-left: 11%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  h4 {
    font-size: 70px;
    font-weight: 600;
    color: #302c48;
    line-height: 98px;
    margin-bottom: 35px;
    margin-top: 0;
  }
  p {
    font-size: 26px;
    font-weight: 400;
    color: #62616b;
    line-height: 62px;
  }
  .brower-list {
    margin-top: 20px;
    display: flex;
    align-items: center;
    .brower-item {
      margin-right: 36px;
      display: flex;
      align-items: center;
    }
    img {
      width: 42px;
      margin-right: 8px;
    }
    span {
      font-size: 26px;
      font-weight: 400;
      color: #007aff;
      line-height: 37px;
    }
  }
}
</style>
